import React, {Component} from "react";
import {Link} from "react-router";

class ShelfNav extends Component {
    dismissShelf() {
        document.querySelector('.navbar-toggle').click();
    }

    render() {
        return (
            <div className="stage-shelf stage-shelf-right hidden" id="sidebar">
                <ul className="nav nav-bordered nav-stacked">
                    <li className="nav-header">About</li>
                    <li className="active">
                        <Link onClick={this.dismissShelf} to="/">Home</Link>
                    </li>
                    <li>
                        <Link onClick={this.dismissShelf} href="#features">Features</Link>
                    </li>
                    <li>
                        <Link onClick={this.dismissShelf} to="/pricing">Pricing</Link>
                    </li>
                    <li>
                        <Link onClick={this.dismissShelf} to="/docs">Documentation</Link>
                    </li>
                    <li className="nav-divider" />
                    <li className="nav-header">Account</li>
                    <li>
                        <Link onClick={this.dismissShelf} to="/register">Register</Link>
                    </li>
                    <li>
                        <Link onClick={this.dismissShelf} to="/login">Log in</Link>
                    </li>
                </ul>
            </div>
        )
    }
}

export default ShelfNav;



// WEBPACK FOOTER //
// ./src/modules/views/common/nav/ShelfNav.js